var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing"},[_c('Order',{attrs:{"value":_vm.orderList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }